import http from '../fetch';
const { get: httpGet, post: httpPost } = http;

// 获取全部文章
export const getAllArticle = url => httpGet(url);



// WEBPACK FOOTER //
// ./src/api/articleList/index.js